import gql from 'graphql-tag';

import { useAdminCaseListViewQuery } from '@/@generated/codegen/API';
import { usePaginationState } from '@/hooks/usePaginationState';
import { PageLoading } from '@/ui/PageLoading';
import { usePrevious } from '@/utils/helpers/react.helper';

import AdminCaseListView from './AdminCaseListView';
import { useAdminCaseListQueryParams } from './hooks/useAdminCaseListQueryParams';

gql`
  query AdminCaseListView(
    $paginationArgs: PaginationArgs!
    $orderByArgs: OrderByArgs
    $where: PatientCaseWhereInput
  ) {
    listPatientCases(paginationArgs: $paginationArgs, orderByArgs: $orderByArgs, where: $where) {
      edges {
        node {
          ...PatientCaseFields
          ...PatientCaseRelationCaseCluster
          ...PatientCaseRelationClient
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

const PAGE_SIZE = 10;
export const patientCaseTablePrefix = 'patientCases';

export default function AdminCaseListClient() {
  const { orderByArgs, paginationArgs, where } = useAdminCaseListQueryParams(
    PAGE_SIZE,
    patientCaseTablePrefix
  );
  const patientCases = useAdminCaseListViewQuery({
    variables: {
      paginationArgs,
      orderByArgs,
      where,
    },
  });
  const pagination = usePaginationState(PAGE_SIZE, patientCaseTablePrefix);
  const previousData = usePrevious(patientCases.data);

  // const data = useMemo(() => {
  //   if (!caseList || caseList.length === 0) return [];
  //   if (caseContents.isCaseLoading) return [];
  //   if (!clientList.data) return [];
  //   if (!caseClusterList) return [];

  //   return Object.keys(caseContents.caseMap).reduce((acc, curr) => {
  //     const unloadedCase: UnloadedIPatientCase = caseList.find((el) => el.id === curr)!;
  //     const caseData = caseContents.caseMap[curr];
  //     const matchedDbClient = clientList.data.find(
  //       (elem) => elem.clientName === unloadedCase.clientName
  //     );
  //     const caseClusterNames = caseClusterList
  //       .filter((el) => el.cases.includes(curr))
  //       .map((el) => el.name);

  //     if (!matchedDbClient) {
  //       console.warn('DB Client not found for case', unloadedCase.clientName);
  //     }

  //     acc.push({
  //       ...unloadedCase,
  //       ...caseData,
  //       numberOfSlides: caseData.slides.length,
  //       clientID: matchedDbClient?.id || null,
  //       caseClusterNames,
  //       searchableName: `${unloadedCase.id} ${unloadedCase.name} ${caseData.displayName}`,
  //     });
  //     return acc;
  //   }, [] as AdminCaseListRowType[]);
  // }, [caseContents, caseIds]);

  if (!patientCases.data && !previousData) {
    return <PageLoading />;
  }
  return (
    <AdminCaseListView
      data={patientCases.data || previousData!}
      pagination={pagination}
      tablePrefix={patientCaseTablePrefix}
    />
  );
}
